enum Profile {
  SYS_ADMIN = '1',
  ADMIN = '2',
  OPERATOR = '3',
  VIEWER = '4',
  AGENT = '5',
  SUPPORT = '7',
}

export default Profile;
